<script setup lang="ts">
import SvgIcon from "~/components/Common/SvgIcon.vue";
import draggable from "vuedraggable";
import { useLearningPathStore } from "~/store/learning-path/learning-path.store";
import Tooltip from "~/components/Common/Tooltip.vue";
import AddTraining from "~/components/Pages/learning-path/component/trainings/AddTraining.vue";
import Card from "~/components/Pages/learning-path/component/trainings/Card.vue";

const learningPathStore = useLearningPathStore();
const { form, hasAttendees, showAddTraining } = storeToRefs(learningPathStore);

function scrollToBottom() {
  setTimeout(() => {
    // Scroll the modal content
    const modalContainer = document.querySelector(".training-course__content");
    if (modalContainer) {
      modalContainer.scrollTo({
        top: modalContainer.scrollHeight,
        behavior: "smooth",
      });
    }
    // Scroll the trainings list
    const listContainer = document.querySelector(".scroll-container");
    if (listContainer) {
      listContainer.scrollTo({
        top: listContainer.scrollHeight,
        behavior: "smooth",
      });
    }
  }, 100);
}

function handleAddTraining(show: boolean) {
  learningPathStore.setShowAddTraining(show);
}

function handleSave(training: any) {
  form.value.trainings.push(training);
  handleAddTraining(false);
  scrollToBottom();
}

watch(showAddTraining, (newValue) => {
  if (newValue && form.value.trainings.length > 0) {
    scrollToBottom();
  }
});
</script>

<template>
  <div class="flex flex-col">
    <div class="flex flex-col gap-1 mb-[48px]">
      <h3 class="heading_3_demi text-primary-color">Formations</h3>
      <span class="body_regular text-secondary-color"
        >Sélectionnez les formations qui composeront votre parcours et définissez leur ordre.</span
      >
    </div>
    <div class="flex flex-col gap-6">
      <draggable
        v-if="form.trainings.length > 0"
        v-model="form.trainings"
        item-key="trainingId"
        handle=".drag-handle"
        ghost-class="trainings_list__dragging"
        drag-class="trainings_list__dragging"
        class="scroll-container"
        :disabled="hasAttendees"
      >
        <template #item="{ element, index }">
          <Card :index="index" :training="element" :disabled="hasAttendees" />
        </template>
      </draggable>
      <AddTraining
        v-if="form.trainings.length === 0 || (form.trainings.length > 0 && !hasAttendees && showAddTraining)"
        @close="handleAddTraining(false)"
        @save="handleSave"
      />
      <div
        v-if="form.trainings.length > 0 && !hasAttendees && !showAddTraining"
        class="flex gap-1 justify-center items-center text-primary-blue-color cursor-pointer"
        @click="handleAddTraining(true)"
      >
        <SvgIcon name="add" class="h-[14px] w-[14px]" />
        <span class="body_regular">Ajouter une formation</span>
      </div>
      <div v-if="form.trainings.length && hasAttendees" class="flex justify-center items-center text-secondary-color">
        <Tooltip :position="'top-right'" append-to-body minified>
          <template #img>
            <div class="flex gap-1 items-center">
              <SvgIcon name="add" class="h-[14px] w-[14px]" />
              <span class="body_regular">Ajouter une formation</span>
            </div>
          </template>
          <template #content>
            <div class="flex gap-2 max-w-[414px] break-words py-3 px-4 items-center">
              <img src="/icons/emojis/eyes.svg" alt="" :style="{ height: '16px', width: '16px' }" />
              <span class="body_regular"
                >Vous ne pouvez pas ajouter de formation à un parcours qui a déjà des participants inscrits.</span
              >
            </div>
          </template>
        </Tooltip>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.scroll-container {
  @apply flex flex-col gap-4 max-h-[56vh] overflow-y-auto pr-2;
}
</style>
